import {useService} from '@cindedi/react-application';
import type {LoaderFunction} from '@remix-run/node';
import {json} from '@remix-run/node';
import {Outlet} from '@remix-run/react';
import {PublicLayout} from '~/domains/organization/components/PublicLayout';

export interface PublicacoesLayoutLoaderData {
  streams: Array<{slug: string; name: string}>;
}

export const loader: LoaderFunction = async function PublicacoesLayoutLoader({context: {use}}) {
  const ResearchStream = use('ResearchStream');
  const streams = await ResearchStream.all();

  return json<PublicacoesLayoutLoaderData>({
    streams: streams
      .sortBy('name')
      .map((s) => ({slug: s.slug, name: s.name}))
      .all(),
  });
};

export default function PublicacoesLayoutView() {
  useService('organization/titlebar').setTitle('Publicações');

  return (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  );
}
